import { useQuery } from 'react-query';
import { http } from '../api/http';

export function useGetMyCards() {
  return useQuery<any, any>('get_my_cards', http.getMyCards);
}
